import { useState } from 'react';

/**
 * Custom hook to show/hide content.
 *
 * @param {boolean} initial The initial `isOpen` state of the element.
 * @returns A stateful value, and functions to update it.
 */
const useDisclosure = (
  initial: boolean = false,
): {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
} => {
  const [isOpen, setIsOpen] = useState(initial);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen((state) => !state);

  return { close, isOpen, open, toggle };
};

export default useDisclosure;
